export class APCreditApplicationUnapplyParametersDto {
    managementCompanyId: number;
    communityId: number;
    creditApplicationId: number;
}
